module.exports = __webpack_public_path__ + "img/edit.29cc53cd.svg";